import lodash from 'lodash';
import { filterAlcoholicItemsFromChoiceSet } from './filterAlcoholic';

export default function tallyAndValidateChoiceSets(
  choiceSets: ChoiceSetWithQuantity[],
  choiceSetDiscountConfig?: ChoiceSetQuantityDiscountConfig,
  isUserUnderage?: boolean,
): ValidatedChoiceSet[] {
  let discount: string;
  if (choiceSetDiscountConfig) {
    discount = choiceSetDiscountConfig.discountPlu;
  }

  let filteredChoiceSets = choiceSets;

  if (isUserUnderage) {
    filteredChoiceSets = choiceSets.map(
      choiceSet =>
        filterAlcoholicItemsFromChoiceSet(choiceSet) as ChoiceSetWithQuantity,
    );
  }

  return filteredChoiceSets?.map(choiceSet => {
    function removeDiscountPLU(choice: any) {
      return choice.plucode != discount;
    }

    const arrayWithoutDiscountPLU = choiceSet.choices.filter(removeDiscountPLU);

    const quantity = lodash.sumBy(arrayWithoutDiscountPLU, 'quantity');

    let valid = true;
    if (choiceSet.required && quantity === 0) {
      valid = false;
    }

    if (choiceSet.max && quantity > choiceSet.max) {
      valid = false;
    }

    if (choiceSet.min && quantity && quantity < choiceSet.min) {
      valid = false;
    }

    return {
      ...choiceSet,
      quantity,
      valid,
    };
  });
}
